"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var fabric_1 = require("fabric");
var constants_1 = require("../common/constants");
var fabric_2 = __importDefault(require("../utils/fabric"));
var Base_1 = __importDefault(require("./Base"));
var Frame = /** @class */ (function (_super) {
    __extends(Frame, _super);
    function Frame(props) {
        var _this = _super.call(this, props) || this;
        _this.setHoverCursor = function (cursor) {
            var background = _this.background;
            if (background) {
                background.set("hoverCursor", cursor);
            }
        };
        _this.setBackgroundColor = function (color) {
            var background = _this.background;
            if (background) {
                background.set({
                    fill: color,
                });
                _this.canvas.requestRenderAll();
                _this.editor.history.save();
            }
        };
        _this.setBackgroundGradient = function (_a) {
            var angle = _a.angle, colors = _a.colors;
            var background = _this.background;
            if (background) {
                (0, fabric_2.default)(background, angle, colors);
                _this.canvas.requestRenderAll();
                _this.editor.history.save();
            }
        };
        _this.initialize();
        return _this;
    }
    Frame.prototype.initialize = function () {
        var _this = this;
        var frame = new fabric_1.fabric.Frame(__assign(__assign({}, constants_1.defaultFrameOptions), { absolutePositioned: this.config.clipToFrame }));
        var background = new fabric_1.fabric.Background(__assign(__assign({}, constants_1.defaultBackgroundOptions), { shadow: this.config.shadow }));
        this.canvas.add(frame, background);
        var center = this.canvas.getCenter();
        frame.center();
        background.center();
        this.state.setFrame({
            height: constants_1.defaultFrameOptions.width,
            width: constants_1.defaultFrameOptions.height,
        });
        setTimeout(function () {
            _this.editor.zoom.zoomToFit();
            _this.editor.history.initialize();
        }, 50);
    };
    Object.defineProperty(Frame.prototype, "frame", {
        get: function () {
            return this.canvas.getObjects().find(function (object) { return object.type === constants_1.LayerType.FRAME; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Frame.prototype, "background", {
        get: function () {
            return this.canvas
                .getObjects()
                .find(function (object) { return object.type === constants_1.LayerType.BACKGROUND; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Frame.prototype, "options", {
        get: function () {
            var options = this.frame.toJSON(this.config.propertiesToInclude);
            return options;
        },
        enumerable: false,
        configurable: true
    });
    Frame.prototype.resize = function (_a) {
        var height = _a.height, width = _a.width;
        this.state.setFrame({
            height: height,
            width: width,
        });
        var frame = this.frame;
        var background = this.background;
        frame.set({ width: width, height: height });
        frame.center();
        if (background) {
            background.set({ width: width, height: height });
            background.center();
        }
        this.editor.zoom.zoomToFit();
    };
    Frame.prototype.getBoundingClientRect = function () {
        var frame = this.frame;
        return frame.getBoundingRect();
    };
    Object.defineProperty(Frame.prototype, "fitRatio", {
        get: function () {
            var options = this.frame;
            var canvasWidth = this.canvas.getWidth() - this.config.frameMargin;
            var canvasHeight = this.canvas.getHeight() - this.config.frameMargin;
            var scaleX = canvasWidth / options.width;
            var scaleY = canvasHeight / options.height;
            if (options.height >= options.width) {
                scaleX = scaleY;
                if (canvasWidth < options.width * scaleX) {
                    scaleX = scaleX * (canvasWidth / (options.width * scaleX));
                }
            }
            else {
                if (canvasHeight < options.height * scaleX) {
                    scaleX = scaleX * (canvasHeight / (options.height * scaleX));
                }
            }
            return scaleX;
        },
        enumerable: false,
        configurable: true
    });
    return Frame;
}(Base_1.default));
exports.default = Frame;
//# sourceMappingURL=Frame.js.map